import { Box, Breadcrumb, Carousel } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { layout } from 'styled-system';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { Section } from '../../../../components/Section';
import { dateFormat } from '../../../../utils/dateFormat';
import { ArticleContent } from '../../../ArticleContent';
import PageNotFound from '../../error/404';

const BreadcrumbWrapper = styled(Box)`
  ${layout}
`;

const GET_CME_GUIDELINE_RECORD = gql`
  query getCMEGuidelineRecord($id: uuid!) {
    record: hkdutest_cme_about_us_by_pk(id: $id) {
      id
      author {
        name
        email
      }
      name
      content
      cover_file {
        link
      }
      created_at
    }
  }
`;

const GuidelineContent = ({ id, uri }) => (
  <Query query={GET_CME_GUIDELINE_RECORD} variables={{ id }}>
    {({ data, loading }) => {
      if (!loading && !R.prop('record', data)) {
        return <PageNotFound />;
      }

      const record = R.propOr({}, 'record', data);
      const coverUrl = R.pathOr(defaultCover, ['cover_file', 'link'], record);
      const title = R.propOr('', 'name', record);
      const content = R.propOr('', 'content', record);
      const authorName = R.pathOr('', ['author', 'name'], record);
      const createdAt = R.propOr(null, 'created_at', record);
      const info = `${authorName} Published at ${createdAt ? dateFormat(createdAt) : ''}`;

      return (
        <Section>
          <Helmet>
            <title>{title} - HKDU CME</title>
          </Helmet>
          <Carousel>
            <Carousel.Slide backgroundImage={`url(${coverUrl})`} height={['150px', '300px']} />
          </Carousel>
          <BreadcrumbWrapper mt={5} display={['none', 'block']}>
            <Breadcrumb>
              <Breadcrumb.Item linkProps={{ as: Link, to: R.replace(id, '', uri) }}>
                Guidelines
              </Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          </BreadcrumbWrapper>
          <ArticleContent title={title} info={info} content={content} />
        </Section>
      );
    }}
  </Query>
);

export default GuidelineContent;
